<template>
  <div class="change-password">
    <AuthBody title="Восстановление пароля">
      <form @submit.prevent="handleSubmit"
            v-if="isCorrect">
        <section class="group">
          <label for="first-password">Новый пароль</label>
          <input id="first-password"
                 class="form-control--flat"
                 type="password"
                 name="password"
                 v-model="firstPassword"
                 data-vv-as="'Пароль'"
                 @focus="handleFocusEl"
                 v-validate="'min:8|verify_password'"
                 required/>
          <p v-show="errors.has('password')"
             class="change-password__error">
            {{ errors.first('password') }}
          </p>
        </section>

        <section class="group">
          <label for="second-password">Повторите пароль</label>
          <input id="second-password"
                 class="form-control--flat"
                 type="password"
                 v-model="secondPassword"
                 required/>
        </section>

        <div v-if="passwordsDoNotMatch" class="change-password__error">
          Пароли не совпадают
        </div>

        <section class="btn-group">
          <button class="button btn-group__submit-btn" :disabled="!formIsValid">
            Изменить пароль
          </button>
        </section>
      </form>

      <div v-else class="change-password__incorrect-code">
        Некорректный код для восстановления пароля
      </div>
    </AuthBody>
  </div>
</template>

<script>
import AuthBody from '@/views/Authorize/components/AuthBody.vue';
import validationResponseHandlerMixin from '@/mixins/validation-response-handler';
import { changePassword, isRestorePasswordCodeCorrect } from '@/api/auth';


export default {
  mixins: [validationResponseHandlerMixin],

  components: {
    AuthBody,
  },

  data() {
    return {
      isCorrect: true,

      firstPassword: '',
      secondPassword: '',
    };
  },

  computed: {
    passwordsDoNotMatch() {
      return ((this.firstPassword !== this.secondPassword)
              && (this.firstPassword && this.secondPassword));
    },

    formIsValid() {
      const passwordsMatch = (
        (this.firstPassword === this.secondPassword)
         && this.secondPassword
         && this.firstPassword
      );

      return passwordsMatch && !this.errors.first('password');
    },
  },

  async beforeRouteEnter({ params }, from, next) {
    const { code } = params;
    let isCorrect = false;

    if (code) {
      try {
        await isRestorePasswordCodeCorrect(code);
        isCorrect = true;
      } catch (e) {
        console.error('Некорректный код для восстановления пароля');
      }
    }

    next((vm) => { vm.setData(isCorrect); });
  },

  methods: {
    setData(isCorrect) {
      this.isCorrect = isCorrect;
    },

    async handleSubmit() {
      try {
        await changePassword(this.$route.params.code, this.firstPassword);

        this.$router.push({ name: 'sign-in' });
      } catch ({ response }) {
        const { data } = response;

        if (data && data.form_errors) {
          this.displayServerErrors(data.form_errors);
        }
      }
    },

    handleFocusEl(event) {
      this.removeServerError(event.currentTarget.name);
    },
  },
};
</script>

<style lang="scss" scoped>
.change-password {
  &__error {
    color: #FC402F;
    font-size: 12px;
    margin-bottom: 14px;
  }

  &__incorrect-code {
    text-align: center;
  }
}
</style>
